import { types } from 'mobx-state-tree';

export default types.model('PaymentSeller', {
  login: '',
  num_items: 0,
  name: types.maybeNull(types.string),
  first_name: types.maybeNull(types.string),
});
